/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
import React, {
  forwardRef, useEffect, useMemo,
} from 'react';
import {
  Dialog, DialogContent, DialogTitle, IconButton,
  Zoom,
} from '@mui/material';
import Button from '@mui/material/Button';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { TransitionProps } from '@mui/material/transitions';
import { TypesSyncByModal } from './utils/Type';
import { RootState } from '../../../../../../redux/rootState';
import { ReportFormDefault } from './utils/helper';
import { Empty } from '../../../../../ScreenAddSmc/Utils/TypeSmc';
import ComponentSelectInput from '../../../../../../Common/ComponentSelectInput';
import { updateEligibleAnalystForSync } from '../../redux/jobScheduleSlice';
import { setLoader } from '../../../../../../redux/loaderSlice';

const Transition = forwardRef((
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
  // eslint-disable-next-line react/jsx-props-no-spreading
) => <Zoom ref={ref} {...props} />);

export default function SyncEligibleModal({
  show, setOpenFrom, unitEditData, callback,
}: TypesSyncByModal) {
  const dispatch = useDispatch();
  const { analystList } = useSelector((state: RootState) => state.bidsReducer);
  const { isLoading } = useSelector((state: RootState) => state.jobScheduleReducer);
  const {
    control, setValue, handleSubmit,
  } = useForm<Empty>(
    {
      // resolver: yupResolver(dynamicSchema as Empty),
      defaultValues: ReportFormDefault,
    },
  );

  const eligibleAnalysts = useMemo(() => {
    if (unitEditData?.ScheduleDetails?.AnalystIds?.length > 0) {
      const selectedAnalysts = unitEditData?.ScheduleDetails?.AnalystIds?.split(',') || [];
      const eligibleList = analystList?.filter((analyst: Empty) => selectedAnalysts?.includes(analyst?.Value));
      return eligibleList;
    } return [];
  }, [unitEditData, analystList]);

  useEffect(() => {
    if (eligibleAnalysts?.length > 0) {
      setValue('analyst', unitEditData?.ScheduleDetails?.AnalystId || '');
    }
  }, [eligibleAnalysts, unitEditData]);

  const onClose = () => {
    setOpenFrom(false);
  };
  const successRun = () => {
    callback();
    onClose();
  };
  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  const onSubmit = (data: { analyst: string }) => {
    const payload = {
      scheduleId: unitEditData?.ScheduleDetails?.ScheduleId,
      analystId: data.analyst,
    };
    dispatch(updateEligibleAnalystForSync({ payload, successRun }));
  };

  return (
    <Dialog
      maxWidth="sm"
      PaperProps={{
        className: 'paperStyle',
      }}
      open={show}
      transitionDuration={500}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => onClose()}
    >
      <DialogTitle className="dialogTitle_style">
        <div className="dialogTitle_style_div">
          <div className="customerInfo">Analyst eligible for sync</div>
        </div>
        <IconButton
          aria-label="close"
          onClick={() => onClose()}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className="dialogContent_style">
        <div className="dialogContent_style_div p16 ">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="div_label_text">
              <label className="label_Style_Customer">Select Analyst eligible for sync</label>
              <ComponentSelectInput
                name="analyst"
                control={control}
                size="small"
                entries={eligibleAnalysts}
              />
            </div>
            <div className="save_and_next_div" style={{ marginTop: '20px' }}>
              <div>
                <Button type="button" className="button_cancel" onClick={() => onClose()}>Close</Button>
              </div>
              <div className="button_margin_left">
                <Button type="submit" className="button_save_and_next">Save</Button>
              </div>
            </div>
          </form>
        </div>
      </DialogContent>
    </Dialog>
  );
}
